import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const USER_TOKEN = "rt_user_token";
export const ADMIN_TOKEN = "rt_admin_token";

function makeClient(tokenKey, loginPath) {
  const c = axios.create({ baseURL: API, timeout: 30000 });
  c.interceptors.request.use((cfg) => {
    const t = localStorage.getItem(tokenKey);
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    return cfg;
  });
  c.interceptors.response.use(
    (r) => r,
    (err) => {
      const url = err?.config?.url || "";
      if (err?.response?.status === 401 && !url.includes("/auth/")) {
        localStorage.removeItem(tokenKey);
        if (!window.location.pathname.startsWith(loginPath)) {
          window.location.href = `${loginPath}?expired=1`;
        }
      }
      return Promise.reject(err);
    }
  );
  return c;
}

export const userApi = makeClient(USER_TOKEN, "/login");
export const adminApi = makeClient(ADMIN_TOKEN, "/admin/login");
export const publicApi = axios.create({ baseURL: API, timeout: 20000 });

export function errMsg(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message === "Network Error" ? "Network error. Check your connection." : fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => String(x.msg || "").replace(/^Value error, /, "")).join(". ");
  return fallback;
}

export const fileUrl = (u) => (u ? (u.startsWith("http") ? u : `${BACKEND_URL}${u}`) : null);
